var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultAvatarUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D7D7DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2 11C17.7227 11 15.7 13.0227 15.7 15.5C15.7 17.9773 17.7227 20 20.2 20C22.6773 20 24.7 17.9773 24.7 15.5C24.7 13.0227 22.6773 11 20.2 11ZM20.2 12.35C21.9477 12.35 23.35 13.7523 23.35 15.5C23.35 17.2477 21.9477 18.65 20.2 18.65C18.4523 18.65 17.05 17.2477 17.05 15.5C17.05 13.7523 18.4523 12.35 20.2 12.35ZM14.7903 21.8C13.8094 21.8 13 22.6094 13 23.5903V24.275C13 25.8969 14.0257 27.1515 15.388 27.9031C16.7503 28.6547 18.4756 29 20.2 29C21.9244 29 23.6497 28.6547 25.012 27.9031C26.1736 27.2623 27.0478 26.2382 27.2928 24.95H27.4009V23.5903C27.4009 22.6094 26.5906 21.8 25.6097 21.8H14.7903ZM14.7903 23.15H25.6097C25.8609 23.15 26.0509 23.3391 26.0509 23.5903V23.6H26.05V24.275C26.05 25.3531 25.4444 26.1235 24.3599 26.7219C23.2753 27.3203 21.7381 27.65 20.2 27.65C18.6619 27.65 17.1247 27.3203 16.0401 26.7219C14.9556 26.1235 14.35 25.3531 14.35 24.275V23.5903C14.35 23.3391 14.5391 23.15 14.7903 23.15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatarUser);
export default __webpack_public_path__ + "static/media/default_avatar_user.2a6dc7c70944f8abfbf659a4a9e16158.svg";
export { ForwardRef as ReactComponent };